// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.freizeit-hinzufuegen-form .form-group input[type="text"],
.freizeit-hinzufuegen-form .form-group input[type="number"],
.freizeit-hinzufuegen-form .form-group textarea {
  background-color: var(--mittelgruen);
  border: none;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  color: var(--dunkelgruen);
  margin-bottom: 15px;
}

.freizeit-hinzufuegen-form input::placeholder,
.freizeit-hinzufuegen-form textarea::placeholder {
  color: #9fb05f;
  opacity: 1;
}

.form-group {
  margin-bottom: 1rem;
  text-align: left;
}


.fv-success-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.fv-success-modal {
  background-color: var(--weiss);
  padding: 1.5rem;
  border-radius: 8px;
  text-align: center;
}

.fv-success-buttons {
  margin-top: 1rem;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}

.fv-success-buttons button {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: var(--dunkelgruen);
  color: var(--weiss);
}

.fv-success-buttons button:hover {
  background-color: #5a7502;
}
`, "",{"version":3,"sources":["webpack://./src/freizeit/freizeithinzufuegen/FreizeitHinzufuegen.css"],"names":[],"mappings":"AAAA;;;EAGE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".freizeit-hinzufuegen-form .form-group input[type=\"text\"],\n.freizeit-hinzufuegen-form .form-group input[type=\"number\"],\n.freizeit-hinzufuegen-form .form-group textarea {\n  background-color: var(--mittelgruen);\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  width: 100%;\n  color: var(--dunkelgruen);\n  margin-bottom: 15px;\n}\n\n.freizeit-hinzufuegen-form input::placeholder,\n.freizeit-hinzufuegen-form textarea::placeholder {\n  color: #9fb05f;\n  opacity: 1;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n  text-align: left;\n}\n\n\n.fv-success-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.fv-success-modal {\n  background-color: var(--weiss);\n  padding: 1.5rem;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.fv-success-buttons {\n  margin-top: 1rem;\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n}\n\n.fv-success-buttons button {\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  background-color: var(--dunkelgruen);\n  color: var(--weiss);\n}\n\n.fv-success-buttons button:hover {\n  background-color: #5a7502;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
